import React, { useState } from 'react';
import { Button, InputGroup, Popover } from '@blueprintjs/core';
import styled from 'styled-components';


const NewShapePopoverContainer = styled.div`
  display: block;
  width: 300px;
  height: auto;
`;

const ShapeTypeHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 23px;
  margin-bottom: 1em;
  padding-top: 1em;
  &:first-child {
    padding-top: 0.5em !important;
  }
`;

const createNewShapeMenu = (
    type,
    newShapeNameInput,
    setNewShapeNameInput,
    handleCreateNewShape
) => {
  const isButtonDisabled = newShapeNameInput.length < 1;

  return (
      <NewShapePopoverContainer>
        <InputGroup
            type="text"
            leftIcon="edit"
            value={newShapeNameInput}
            placeholder={type.replace('_', ' ').replace(/s$/, '') + ' name'}
            name='name'
            autoFocus
            onChange={e => setNewShapeNameInput(e.target.value)}
            onKeyDown={e => {
                if (e.key === 'Enter') handleCreateNewShape(type);
            }}
        />
        <Button
            fill={true}
            disabled={isButtonDisabled}
            intent="primary"
            onClick={() => handleCreateNewShape(type)}
        >
          Create {type.replace('_', ' ').replace(/s$/, '')}
        </Button>
      </NewShapePopoverContainer>
  );
}

const EditShapesHeader = ({
  type,
  title,
  createNewShape,
}) => {
  const [newShapeNameInput, setNewShapeNameInput] = useState('');
  const [popoverOpen, setPopoverOpen] = useState(false);

  const handleCreateNewShape = (type) => {
    createNewShape(type, newShapeNameInput);
    setNewShapeNameInput('');
  };

  return (
    <ShapeTypeHeader>
      <div>{title}</div>
        { type === "areas" || type === "lines"? (<Popover
        position='auto'
        onClose={() => setPopoverOpen(false)}
        content={createNewShapeMenu(
          type,
          newShapeNameInput,
          setNewShapeNameInput,
          handleCreateNewShape
        )}
        isOpen={popoverOpen}
      >
        <Button icon="plus" onClick={() => setPopoverOpen(!popoverOpen)}>Add</Button>
      </Popover>) : null }
    </ShapeTypeHeader>
  );
};

export { EditShapesHeader };